import React from "react";
import "./RateCard.css";

export default function RateCard(props) {
  return (
    <>
      <div key={props.key || 'unique-key-rate-card'} className="card-wrapper">
        <div className="label">
          <span>{props.text}</span>
        </div>
        <div className="value">
          <span>{props.value}</span>
        </div>
      </div>
    </>
  );
}
